var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-recorder-container"},[_c('div',{ref:"barparent",staticClass:"btn-recorder",class:{
      disabled: _vm.status === _vm.RecordBtnStatus.DISABLE || _vm.disabled,
      default: _vm.status === _vm.RecordBtnStatus.INITIAL,
      recording: _vm.status === _vm.RecordBtnStatus.RECORDING,
    },on:{"click":_vm.handleRecordBtnClick}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.buttonText))]),(_vm.status === _vm.RecordBtnStatus.RECORDING)?_c('ProcessWeb',{attrs:{"total-time":_vm.options.duration,"current-time":_vm.currentTime}}):_vm._e(),(_vm.status === _vm.RecordBtnStatus.RECORDING)?_c('Micphone',{attrs:{"wave":this.wave}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }